import { useEffect } from 'react';
import OktaSignIn from '@okta/okta-signin-widget';
import '@okta/okta-signin-widget/css/okta-sign-in.min.css';
import Logger from 'utilities/logger';

const useOktaWidget = (id, config, userLogin) => {
  const logger = Logger('useOktaWidget');
  const signIn = new OktaSignIn(
    userLogin ? { ...config, username: userLogin } : config,
  );

  const mountLogin = () => {
    signIn.showSignInAndRedirect({ el: `#${id}` }).catch(err => {
      // This function is invoked with errors the widget cannot recover from:
      // Known errors: CONFIG_ERROR, UNSUPPORTED_BROWSER_ERROR
      console.error(err);
    });
    signIn.on('ready', function(context) {
      const waitForEl = function(selector, callback) {
        const el = selector();
        if (el) {
          callback(el);
        } else {
          setTimeout(() => {
            waitForEl(selector, callback);
          }, 100);
        }
      };
      if (userLogin) {
        waitForEl(
          () => document.getElementById('idp-discovery-submit'),
          button => button.click(),
        );
      }
      const trigger = () =>
        waitForEl(
          () => {
            const el = document.querySelector(
              '.mfa-verify form[data-se="factor-sms"] .sms-request-button',
            );
            if (el && el.innerText === 'Send code') {
              return el;
            }
            return null;
          },
          el => {
            logger.debug('Sending Authenticate SMS automatically');
            el.click();
            setTimeout(() => {
              logger.debug('Registering sms automatic trigger');
              trigger();
            }, 1000);
          },
        );

      trigger();
    });
  };

  useEffect(() => {
    try {
      mountLogin();
    } catch (err) {
      logger.warn('Okta Widget Loading', err);
      signIn && signIn.remove();
      mountLogin(); // Trying once more time
    }

    return () => {
      try {
        signIn && signIn.remove();
      } catch (e) {
        logger.error(e);
      }
    };
  }, []);
};

export default useOktaWidget;
